import { createAction, handleActions } from 'redux-actions';

// ACTION CREATORS
export const getRulesDiff = createAction('GET_RULES_DIFF');
export const setRulesDiff = createAction('SET_RULES_DIFF');
export const setRulesDiffLoading = createAction('SET_RULES_DIFF_LOADING');
export const clearRulesDiff = createAction('CLEAR_RULES_DIFF');

const initialState = { 
    draftRules: [], 
    liveRules: [], 
    loading: false, 
    loaded: false,  // Track if data has been fetched
    hasChanges: false, 
    totalChanges: 0 
};

// REDUCERS
export const reducer = handleActions(
  new Map([
    [
      setRulesDiff,
      (state, action) => {
        const { draftRules = [], liveRules = [], hasChanges = false, totalChanges = 0 } = action.payload || {};
        return { 
            ...state, 
            draftRules,
            liveRules,
            hasChanges, 
            totalChanges,
            loading: false,
            loaded: true
        };
      }
    ],
    [
      setRulesDiffLoading,
      (state, action) => {
        return { ...state, loading: action.payload };
      }
    ],
    [
      clearRulesDiff,
      () => {
        return { ...initialState, loaded: false };
      }
    ]
  ]),
  initialState
);

// SELECTORS
export const getRulesDiffState = state => state.rulesDiff;
